import React from 'react';

import WaterTable from '../../../../../components/Table/WaterTable';

const Water: React.FC<{selectedYear: string; facilityId: string}> = ({
  selectedYear,
  facilityId
}) => {
  return <WaterTable selectedYear={selectedYear} facilityId={facilityId} />;
};

export default Water;
